import React from 'react';
import { Settings } from 'lucide-react';
import SessionPanel from '../../components/SessionPanel';
import UnidadesPanel from './UnidadesPanel';
import RetencaoLogsPanel from './RetencaoLogsPanel';
import UpdatesPanel from './UpdatesPanel';

const ConfiguracoesPage = () => (
  <div className="flex min-h-full flex-col gap-6 px-1 sm:px-2 lg:px-4">
    <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
      <div>
        <h1 className="flex items-center gap-2 text-2xl font-bold text-slate-800">
          <div className="rounded-lg bg-condo-teal p-2">
            <Settings className="text-condo-dark" size={20} />
          </div>
          Configurações
        </h1>
        <p className="text-sm text-gray-500">Gerencie as unidades, os logs de acesso e as sessões do sistema</p>
      </div>
    </div>

    <UpdatesPanel />
    <UnidadesPanel />
    <RetencaoLogsPanel />
    <RetencaoLogsPanel captures />
    <RetencaoLogsPanel general />
    <SessionPanel />
  </div>
);

export default ConfiguracoesPage;
